<p-contextMenu
  #contextMenu
  styleClass="asset-tree-context-menu"
  appendTo="body"
  [model]="items$ | async"
>
</p-contextMenu>
